export default __webpack_public_path__ + "static/media/picture3.5645fd9b.jpeg";